<template>
  <div 
    v-if="modelValue" 
    class="modal fade show" 
    style="display: block; background-color: rgba(0,0,0,0.5);"
    tabindex="-1" 
    role="dialog"
    @click="handleModalClick"
  >
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h5 class="modal-title">
            {{ budget ? 'Modifica Budget Attività' : 'Nuovo Budget Attività' }}
          </h5>
          <button 
            type="button" 
            class="btn-close" 
            @click="close"
            aria-label="Chiudi"
          ></button>
        </div>
        
        <div class="modal-body">
          <!-- Error nel dialog -->
          <div v-if="error" class="alert alert-danger">
            {{ error }}
          </div>
          
          <!-- Form dinamico da schema DBMng -->
          <DbmngForm
            v-if="dbmngSchema"
            v-model="formData"
            :dbmng-schema="dbmngSchema"
            :show-actions="false"
            :validate-on-change="true"
            @validate="onFormValidate"
          />
          
          <div v-else class="text-center py-4">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Caricamento...</span>
            </div>
          </div>
        </div>
        
        <div class="modal-footer">
          <button 
            type="button" 
            class="btn btn-secondary" 
            @click="close"
            :disabled="isLoading"
          >
            Annulla
          </button>
          <button 
            type="button" 
            class="btn btn-primary" 
            @click="save"
            :disabled="isLoading || !isFormValid"
          >
            <span v-if="isLoading" class="spinner-border spinner-border-sm me-2"></span>
            {{ budget ? 'Salva Modifiche' : 'Crea Budget' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import budgetAPI from '@/services/budgetAPI.js'
import DbmngForm from '@/lib/DbmngForm.vue'

export default {
  name: 'BudgetDialog',
  components: {
    DbmngForm
  },
  
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    budget: {
      type: Object,
      default: null
    },
    dbmngSchema: {
      type: Object,
      default: null
    },
    // Valori predefiniti per il form (es. id_people o id_project)
    defaults: {
      type: Object,
      default: () => ({})
    }
  },
  
  emits: ['update:modelValue', 'saved'],
  
  data() {
    return {
      formData: {},
      isLoading: false,
      error: null,
      isFormValid: true
    }
  },
  
  watch: {
    modelValue(newVal) {
      if (newVal) {
        this.initializeForm()
      }
    },
    budget() {
      if (this.modelValue) {
        this.initializeForm()
      }
    }
  },
  
  mounted() {
    if (this.modelValue) {
      this.initializeForm()
    }
  },
  
  methods: {
    initializeForm() {
      if (this.budget) {
        // Modalità modifica
        this.formData = {
          id_people: this.budget.id_people,
          id_project: this.budget.id_project,
          year: this.budget.year,
          budget: this.budget.budget,
          tipo: this.budget.tipo,
          note: this.budget.note || ''
        }
      } else {
        // Modalità creazione con defaults
        this.formData = {
          id_people: this.defaults.id_people || '',
          id_project: this.defaults.id_project || '',
          year: this.defaults.year || new Date().getFullYear(),
          budget: '',
          tipo: 0,
          note: '',
          ...this.defaults
        }
      }
      this.error = null
    },
    
    onFormValidate(validation) {
      this.isFormValid = validation.valid
    },
    
    async save() {
      try {
        this.isLoading = true
        this.error = null
        
        // Validazione
        const validation = budgetAPI.validateBudget(this.formData)
        if (!validation.valid) {
          this.error = validation.errors.join(', ')
          return
        }
        
        let result
        
        if (this.budget) {
          result = await budgetAPI.update(this.budget.id_budget, this.formData)
        } else {
          result = await budgetAPI.create(this.formData)
        }
        
        if (result.ok) {
          this.$emit('saved', result)
          this.close()
        } else {
          this.error = result.message
        }
        
      } catch (error) {
        this.error = error.message || 'Errore di connessione'
      } finally {
        this.isLoading = false
      }
    },
    
    close() {
      this.$emit('update:modelValue', false)
      this.error = null
      this.isLoading = false
    },
    
    handleModalClick(event) {
      // Modale non si chiude quando si clicca fuori
      // if (event.target === event.currentTarget) {
      //   this.close()
      // }
    }
  }
}
</script>

<style scoped>
/* Dialog Modal Styles */
.modal.show {
  animation: modalFadeIn 0.3s ease-out;
}

@keyframes modalFadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.modal-dialog {
  animation: modalSlideIn 0.3s ease-out;
}

@keyframes modalSlideIn {
  from {
    transform: translateY(-50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.modal-content {
  border: none;
  box-shadow: 0 10px 30px rgba(0,0,0,0.3);
  border-radius: 12px;
}

.modal-header {
  background-color: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
  border-radius: 12px 12px 0 0;
}

.modal-title {
  font-weight: 600;
  color: #495057;
}

.btn-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  font-weight: bold;
  color: #000;
  opacity: 0.5;
  cursor: pointer;
}

.btn-close:hover {
  opacity: 0.8;
}

.btn-close:before {
  content: '×';
}
</style>
